import request from "@/utils/request.js"
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)

export function getList(parm){
    return request.get("/worklog",{
        params:parm
    })
}
export function addWl(parm){
	parm = {...parm,cmpid:user.cmpid}
    return request.post("/worklog",{
        data:parm
    })
}

export function addmul(parm){
    return request.post("/worklog/addmul",{
        data:parm
    })
}
export function updateWl(parm){
    return request.put("/worklog",{
        data:parm
    })
}
export function getlastWl(parm){
    return request.get("/worklog/last",{
		params:parm
		}
	)
}
export function deleteWl(parm){
    return request.delete("/worklog",{
        params:parm
    })
}
export function exportall(parm){
    return request.get("/worklog/export",{
        params:parm
    })
}